export default "__VITE_ASSET__71a475e8__"